import Em from 'ember';
const MOBILE_DEVICES = ['android', 'ios'];
export function mobileDeviceClass(params) {
  let deviceType = params[0];
  if (MOBILE_DEVICES.includes(deviceType)) {
    return `o__${deviceType}`;
  }
  return '';
}
export default Em.Helper.helper(mobileDeviceClass);